export default __webpack_public_path__ + "static/media/CV-EN.017906eb.pdf";